export const UTM_MEDIUM = {
    NATIVE: { type: 'mobile_native' },
    FACEBOOK: { type: 'Facebook', link: 'https://www.facebook.com/sharer/sharer.php?u=' },
    TWITTER: { type: 'Twitter', link: 'https://twitter.com/share?url=' },
    PINTEREST: { type: 'Pinterest', link: 'https://www.pinterest.com/pin/create/button/?url=' },
    LINKEDIN: { type: 'Linkedin', link: 'https://www.linkedin.com/shareArticle?url=' },
    TUMBLR: { type: 'Tumblr', link: 'https://www.tumblr.com/widgets/share/tool?canonicalUrl=' },
    REDDIT: { type: 'Reddit', link: 'https://www.reddit.com/submit?url=' },
    WHATSAPP: { type: 'Whatsapp', link: 'https://web.whatsapp.com/send?text=' },
    MESSENGER: { type: 'Messenger', link: 'https://www.facebook.com/dialog/send?link=' },
    TELEGRAM: { type: 'Telegram', link: 'https://telegram.me/share/url?url=' },
    LINE: { type: 'Line', link: 'https://social-plugins.line.me/lineit/share?url=' },
    MKTG_FB: 'host_mktg_fb',
};
